import { MatTableDataSource } from '@angular/material/table';
import { Payload, Person, PolizzeResult, RightType } from '@o30/entities';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export enum ListTyp {
  OFFERT = 'OFFERT',
  BERATUNG_EMPFEHLUNG = 'BERATUNG_EMPFEHLUNG',
  ANTRAG = 'ANTRAG',
  VERDORBENER_ANTRAG = 'VERDORBENER_ANTRAG',
  GENHEMIGUNG = 'GENHEMIGUNG',
  VORL_DECKUNG = 'VORL_DECKUNG',
  SCHWEBE = 'SCHWEBE',
  LEBEN_AENDERUNGSOFFERT = 'LEBEN_AENDERUNGSOFFERT',
  OFFENE_MAKLER_ANTRAEGE = 'OFFENE_MAKLER_ANTRAEGE',
  OFFENE_UNBETREUTE_MAKLER_ANTRAEGE = 'OFFENE_UNBETREUTE_MAKLER_ANTRAEGE',
  NICHT_FREIGEGEBENE_MAKLER_ANTRAEGE = 'NICHT_FREIGEGEBENE_MAKLER_ANTRAEGE'
}

/**
 * header has to be unique right now
 * if the header string is not unique for some reason there should be a unique id
 * so @for can track properly by id
 */
export interface OfferteAntraegeTableColumn {
  columnDef: string;
  header: string;
  cell: (row: ExpandableRow<PolizzeResult>) => string;
  sortable?: boolean;
}

export interface ExpandableRow<T> extends ExpandableRowBase<T> {
}

export interface ExpandedRowAddition<T> extends ExpandableRowBase<T> {
  expandedRow: boolean;
}

export interface ExpandableRowBase<T> {
  data: T;
  isExpanded: boolean;
}

export interface OffertStageTwoRowAddition<T> extends ExpandableRowBase<T> {
  detailRow: boolean;
}

export class ListData {
  dataSource = new MatTableDataSource<ExpandableRow<PolizzeResult> | ExpandedRowAddition<PolizzeResult> | OffertStageTwoRowAddition<PolizzeResult>>();
  loading: boolean;
  loadingFinished: BehaviorSubject<boolean> = new BehaviorSubject(false);
  reloadListSubject: Subject<ListTyp> = new Subject<ListTyp>();
}

export interface ListDataConfig {
  getData: () => Observable<Payload<PolizzeResult[]>>;
  getDataForKunde: (kundeId: Person['id']) => Observable<Payload<PolizzeResult[]>>;
  dataSource: ListData;
  getExpandedRows?: (data: PolizzeResult, iddBefreit?: boolean) => PolizzeRowAddition[];
  right?: RightType;
}

export type PolizzeRowAddition = ExpandedRowAddition<PolizzeResult> | OffertStageTwoRowAddition<PolizzeResult>;
